import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=7f59e042&scoped=true&"
import script from "./EmployeeCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=7f59e042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59e042",
  null
  
)

export default component.exports